import {
  Globe2,
  Link2,
  Heart,
  BookOpen,
  Sparkles,
  Clock3,
} from "lucide-react";

import "./CareerBenefits.css";

const benefits = [
  {
    icon: Globe2,
    title: "Remote-First Culture",
    description:
      "Work from anywhere in the world. We focus on impact and output, not hours spent sitting in an office chair.",
  },
  {
    icon: Link2,
    title: "Generous Equity",
    description:
      "We want everyone at Xyncely to behave like an owner. Every single full-time employee receives stock options.",
  },
  {
    icon: Heart,
    title: "Premium Health Care",
    description:
      "Comprehensive medical, dental, and vision insurance coverage for you and your dependents, completely covered.",
  },
  {
    icon: BookOpen,
    title: "Learning & Development",
    description:
      "A yearly personal budget of $2,000 for books, courses, conferences, or coaching to accelerate your growth.",
  },
  {
    icon: Sparkles,
    title: "Annual Team Offsites",
    description:
      "Twice a year we gather the entire global team in inspiring locations to connect, align, and have fun together.",
  },
  {
    icon: Clock3,
    title: "Flexible Working Hours",
    description:
      "Life happens. Design your own schedule that lets you balance professional impact with personal well-being.",
  },
];

const CareersBenefits = () => {
  return (
    <section className="careers-benefits">
      <div className="careers-benefits__header">
        <span className="careers-benefits__eyebrow">
          WHY XYNCELY
        </span>

        <h2>Supporting you on and off the field</h2>

        <p>
          We build tools to help brands grow, and we build an environment that
          helps our people thrive. Here is what we offer.
        </p>
      </div>

      <div className="careers-benefits__grid">
        {benefits.map((benefit) => {
          const Icon = benefit.icon;

          return (
            <article
              className="careers-benefits__card"
              key={benefit.title}
            >
              <div className="careers-benefits__icon">
                <Icon size={16} strokeWidth={1.8} />
              </div>

              <h3>{benefit.title}</h3>

              <p>{benefit.description}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default CareersBenefits;